<template>
  <v-dialog v-model="dialog" max-width="100%" persistent scrollable>
    <v-card>
      <v-card-title class="py-2 px-4 blue darken-3 white--text">
        <div class="d-flex">
          <span>Reemplazar Documento</span>

          <template v-if="nombreCompletoEstudiante && tipoDocumentoPersona">
            <span class="ml-2"> de {{ nombreCompletoEstudiante }} </span>

            <span class="ml-2 subtitle-1 grey--text"> ({{ tipoDocumentoPersona.nombre }}) </span>
          </template>
        </div>

        <v-spacer></v-spacer>

        <v-btn icon dark @click="cerrar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-container v-if="cargando" class="fill-height">
          <v-row align="center" justify="center">
            <v-col cols="12" class="text-center">
              <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>

              <p class="mt-4">Cargando documento...</p>
            </v-col>
          </v-row>
        </v-container>

        <v-container v-else-if="error" class="fill-height">
          <v-row align="center" justify="center">
            <v-col cols="12" class="text-center">
              <v-icon color="error" size="64">mdi-alert-circle</v-icon>

              <p class="mt-4 error--text">{{ mensajeError }}</p>
            </v-col>
          </v-row>
        </v-container>

        <div v-else-if="documentoPersona">
          <v-row dense>
            <!-- Documento Actual -->
            <v-col cols="12" md="6">
              <v-card outlined>
                <v-card-subtitle class="py-2 blue lighten-5">
                  <strong>
                    <v-icon small class="mr-1">mdi-file-document</v-icon>
                    Documento Actual
                  </strong>
                </v-card-subtitle>

                <v-card-text class="pa-2">
                  <v-card flat outlined class="mb-4">
                    <v-card-text>
                      <v-row dense>
                        <v-col cols="12" md="6">
                          <div class="mb-2 d-flex align-center">
                            <strong>Estado:</strong>

                            <v-chip class="ml-2" small dark :color="colorEstado">
                              {{ documentoPersona.estadoRevision }}
                            </v-chip>
                          </div>
                        </v-col>

                        <v-col cols="12" md="6">
                          <div class="mb-2">
                            <strong>Fecha de Revisión:</strong>
                            <span class="ml-2">{{ formatearFecha(documentoPersona.fechaHoraRevision) }}</span>
                          </div>

                          <div class="mb-2" v-if="documentoPersona.fechaVencimiento">
                            <strong>Fecha de Vencimiento:</strong>
                            <span class="ml-2">{{ formatearFecha(documentoPersona.fechaVencimiento) }}</span>
                          </div>
                        </v-col>

                        <v-col cols="12">
                          <div class="mb-2">
                            <strong>Observaciones:</strong>
                            <span class="ml-2 text-caption">{{ documentoPersona.observaciones || '-' }}</span>
                          </div>
                        </v-col>

                        <v-col cols="12">
                          <strong>Datos del Documento</strong>
                        </v-col>

                        <v-col v-for="dato in documentoPersona.datos" :key="dato.id" cols="12">
                          <strong>{{ dato.nombre }}:</strong>
                          <span class="ml-2 text-caption">{{ dato.valor }}</span>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>

                  <v-btn class="mb-2" small text color="primary" @click="descargarDocumentoActual">
                    <v-icon small left>mdi-download</v-icon>
                    Descargar actual
                  </v-btn>

                  <div class="documento-viewer">
                    <iframe
                      v-if="esPdfActual"
                      :src="urlDocumentoActual"
                      width="100%"
                      height="500px"
                      style="border: none"></iframe>

                    <div v-else-if="esImagenActual" class="text-center">
                      <v-img :src="urlDocumentoActual" max-height="500" contain></v-img>
                    </div>

                    <div v-else class="text-center pa-8">
                      <v-icon size="64" color="grey">mdi-file-document-outline</v-icon>
                      <p class="mt-4">Formato no soportado para previsualización</p>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>

            <!-- Documento Nuevo -->
            <v-col cols="12" md="6">
              <v-card outlined>
                <v-card-subtitle class="py-2 green lighten-5">
                  <strong>
                    <v-icon small class="mr-1">mdi-file-upload</v-icon>
                    Documento Nuevo
                  </strong>
                </v-card-subtitle>

                <v-card-text class="pa-2">
                  <v-card flat outlined class="mb-4">
                    <v-card-text>
                      <v-form ref="formReemplazo">
                        <!-- Selector de archivo -->
                        <v-file-input
                          v-model="nuevoArchivo"
                          class="mb-2"
                          label="Seleccionar nuevo documento"
                          prepend-icon="mdi-paperclip"
                          accept="image/*,application/pdf"
                          :rules="[reglas.requerido, reglas.tamanoMaximo]"
                          :truncate-length="30"
                          required
                          dense
                          clearable
                          outlined
                          show-size
                          @change="onChangeNuevoArchivo"></v-file-input>

                        <div v-if="tipoDocumentoPersona.aplicaFechaVencimiento" class="d-flex flex-wrap align-start">
                          <v-menu
                            v-model="documentoPersonaNuevo.menuFechaVencimiento"
                            transition="scale-transition"
                            min-width="290px"
                            :close-on-content-click="false"
                            offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-bind="attrs"
                                v-on="on"
                                v-model="documentoPersonaNuevo.fechaVencimiento"
                                prepend-inner-icon="mdi-calendar"
                                label="Fecha de Vencimiento"
                                placeholder="Fecha de Vencimiento"
                                :rules="[
                                  (v) =>
                                    !!v || documentoPersonaNuevo.esIndefinido || 'La fecha de vencimiento es requerida',
                                ]"
                                :disabled="documentoPersonaNuevo.esIndefinido"
                                dense
                                outlined
                                readonly></v-text-field>
                            </template>

                            <v-date-picker
                              v-model="documentoPersonaNuevo.fechaVencimiento"
                              :disabled="documentoPersonaNuevo.esIndefinido"
                              :min="
                                new Date()
                                  .toLocaleString('es-BO', {
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                  })
                                  .split('/')
                                  .reverse()
                                  .join('-')
                              "
                              @input="documentoPersonaNuevo.menuFechaVencimiento = false"></v-date-picker>
                          </v-menu>

                          <v-checkbox
                            v-model="documentoPersonaNuevo.esIndefinido"
                            class="mt-1 ml-sm-3"
                            label="Indefinido"
                            @change="
                              () => {
                                documentoPersonaNuevo.fechaVencimiento = null;
                              }
                            "></v-checkbox>
                        </div>

                        <!-- Campos de datos dinámicos -->
                        <v-row v-if="documentoPersonaNuevo.datos" dense>
                          <v-col v-for="campo in documentoPersonaNuevo.datos" :key="campo.id" cols="12">
                            <!-- Campo de fecha -->
                            <v-menu
                              v-if="campo.tipo === tiposCampos.FECHA"
                              v-model="campo.menuFecha"
                              :ref="`menu-${campo.id}`"
                              transition="scale-transition"
                              min-width="290px"
                              :close-on-content-click="false"
                              offset-y>
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-bind="attrs"
                                  v-on="on"
                                  v-model="campo.valor"
                                  prepend-inner-icon="mdi-calendar"
                                  :name="campo.id"
                                  :label="campo.nombre"
                                  :placeholder="campo.nombre"
                                  :rules="[(v) => !!v || `${campo.nombre} requerido`]"
                                  dense
                                  outlined
                                  readonly></v-text-field>
                              </template>

                              <v-date-picker v-model="campo.valor" @input="campo.menuFecha = false"></v-date-picker>
                            </v-menu>

                            <!-- Campo de número -->
                            <v-text-field
                              v-else-if="campo.tipo === tiposCampos.NUMERO"
                              v-model.number="campo.valor"
                              type="number"
                              :name="campo.id"
                              :label="campo.nombre"
                              :placeholder="campo.nombre"
                              :rules="[
                                (v) => (v !== '' && v !== null && v !== undefined) || `${campo.nombre} requerido`,
                              ]"
                              dense
                              outlined></v-text-field>

                            <!-- Campo de texto largo -->
                            <v-textarea
                              v-else-if="campo.tipo === tiposCampos.TEXTO"
                              v-model="campo.valor"
                              rows="3"
                              :name="campo.id"
                              :label="campo.nombre"
                              :placeholder="campo.nombre"
                              :rules="[(v) => !!v || `${campo.nombre} requerido`]"
                              dense
                              outlined></v-textarea>

                            <!-- Campo de selección múltiple -->
                            <v-select
                              v-else-if="campo.tipo === tiposCampos.SELECCION_MULTIPLE"
                              v-model="campo.valor"
                              :items="campo.opciones || []"
                              :name="campo.id"
                              :label="campo.nombre"
                              :placeholder="`Seleccione una o más opciones para ${campo.nombre}`"
                              :rules="[(v) => (v && v.length > 0) || `${campo.nombre} requerido`]"
                              dense
                              outlined></v-select>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-card-text>
                  </v-card>

                  <!-- Previsualización del nuevo documento -->
                  <div v-if="nuevoArchivo" class="documento-viewer">
                    <iframe
                      v-if="esPdfNuevo"
                      :src="urlDocumentoNuevo"
                      width="100%"
                      height="400px"
                      style="border: none"></iframe>

                    <div v-else-if="esImagenNuevo" class="text-center">
                      <v-img :src="urlDocumentoNuevo" max-height="400" contain></v-img>
                    </div>

                    <div v-else class="text-center pa-8">
                      <v-icon size="64" color="grey">mdi-file-document-outline</v-icon>
                      <p class="mt-4">Formato no soportado para previsualización</p>
                    </div>
                  </div>

                  <div v-else class="documento-viewer text-center pa-16">
                    <v-icon size="100" color="grey lighten-2">mdi-cloud-upload</v-icon>
                    <p class="mt-4 grey--text">Seleccione un archivo para previsualizar</p>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text :disabled="reemplazando" @click="cerrar">
          <v-icon left small>mdi-close</v-icon>
          Cancelar
        </v-btn>

        <v-btn color="primary" :loading="reemplazando" @click="confirmarReemplazo">
          <v-icon left small>mdi-swap-horizontal</v-icon>

          Reemplazar Documento
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialogConfirmacion" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline">
          <v-icon color="warning" class="mr-2">mdi-alert</v-icon>
          Confirmar Reemplazo
        </v-card-title>

        <v-card-text>
          <template v-if="nombreCompletoEstudiante && tipoDocumentoPersona">
            ¿Está seguro que desea reemplazar el documento actual?
            <br />
            <br />
            <strong>Documento:</strong> {{ tipoDocumentoPersona.nombre }}
            <br />
            <strong>Estudiante:</strong> {{ nombreCompletoEstudiante }}
            <br />
            <br />
            <v-alert type="warning" dense text>Esta acción no se puede deshacer.</v-alert>
          </template>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text :disabled="reemplazando" @click="dialogConfirmacion = false"> Cancelar </v-btn>

          <v-btn color="primary" :loading="reemplazando" @click="reemplazarDocumento"> Confirmar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <notifications group="notifications" position="top right" />
  </v-dialog>
</template>

<script>
import inscripcionesDocumentosPersonasService from '../../../comisiones/services/inscripciones-documentos-personas.service';
import { TIPOS_CAMPOS } from '../../../comisiones/utils/constantes';
import { concatenar } from '../../../pagos/utils/funciones';

export default {
  name: 'ReemplazarInscripcionDocumentoPersona',
  data() {
    return {
      dialog: false,
      dialogConfirmacion: false,
      cargando: false,
      reemplazando: false,
      error: false,
      mensajeError: '',
      inscripcionDocumentoPersona: null,
      inscripcionDocumentoPersonaId: null,
      nuevoArchivo: null,
      urlDocumentoNuevo: null,
      reglas: {
        requerido: (v) => !!v || 'Este campo es requerido',
        tamanoMaximo: (v) => !v || v.size <= 5 * 1024 * 1024 || 'El archivo no debe superar los 5 MB',
      },
      tiposCampos: TIPOS_CAMPOS,
      documentoPersonaNuevo: {
        archivoBase64: null,
        esIndefinido: false,
        fechaVencimiento: null,
        menuFechaVencimiento: false,
        tipoDocumentoPersonaId: null,
        datos: [],
      },
    };
  },
  computed: {
    inscripcion() {
      return this.inscripcionDocumentoPersona?.inscripcion;
    },
    estudiante() {
      return this.inscripcion?.estudiante;
    },
    nombreCompletoEstudiante() {
      if (!this.estudiante) {
        return '';
      }

      return concatenar(this.estudiante.nombres, this.estudiante.primerApellido, this.estudiante.segundoApellido);
    },
    documentoPersona() {
      return this.inscripcionDocumentoPersona?.documentoPersona;
    },
    tipoDocumentoPersona() {
      return this.documentoPersona?.tipoDocumentoPersona;
    },
    // Documento actual
    esPdfActual() {
      return this.documentoPersona?.archivo?.mimetype === 'application/pdf';
    },
    esImagenActual() {
      const mimetype = this.documentoPersona?.archivo?.mimetype || '';
      return mimetype.startsWith('image/');
    },
    urlDocumentoActual() {
      if (!this.documentoPersona?.archivo?.file64) return '';

      return this.base64AUrl(this.documentoPersona.archivo.file64, this.documentoPersona.archivo.mimetype);
    },
    esPdfNuevo() {
      return this.nuevoArchivo?.type === 'application/pdf';
    },
    esImagenNuevo() {
      return this.nuevoArchivo?.type.startsWith('image/');
    },
    colorEstado() {
      const estado = this.documentoPersona?.estadoRevision;
      const colores = {
        pendiente: 'orange',
        aprobado: 'success',
        rechazado: 'error',
      };

      return colores[estado] || 'grey';
    },
  },
  methods: {
    async abrir(inscripcionDocumentoPersonaId) {
      this.inscripcionDocumentoPersonaId = inscripcionDocumentoPersonaId;
      this.dialog = true;
      this.nuevoArchivo = null;
      this.urlDocumentoNuevo = null;
      this.error = false;
      this.mensajeError = '';

      await this.cargarDocumento(inscripcionDocumentoPersonaId);
    },
    async cargarDocumento(id) {
      this.cargando = true;
      this.inscripcionDocumentoPersona = null;

      try {
        const response = await inscripcionesDocumentosPersonasService.findOne(id);
        const data = response.data;

        this.inscripcionDocumentoPersona = data?.datos || null;
        this.documentoPersonaNuevo.datos =
          this.inscripcionDocumentoPersona?.documentoPersona?.datos.map((dato) => ({
            ...dato,
            valor: null,
            menuFecha: dato.tipo === 'date' ? false : undefined,
            fecha: dato.tipo === 'date' ? null : undefined,
          })) || [];
      } catch (err) {
        const response = err.response;
        const data = response?.data;

        this.error = true;
        this.mensajeError = data?.mensaje || 'Error al cargar el documento';

        window.console.error('Error al cargar documento:', err);
      } finally {
        this.cargando = false;
      }
    },
    cerrar() {
      this.dialog = false;
      this.dialogConfirmacion = false;
      this.inscripcionDocumentoPersona = null;
      this.inscripcionDocumentoPersonaId = null;
      this.nuevoArchivo = null;
      this.urlDocumentoNuevo = null;
      this.error = false;
      this.mensajeError = '';

      if (this.$refs.formReemplazo) {
        this.$refs.formReemplazo.reset();
      }
    },
    onChangeNuevoArchivo(archivo) {
      if (archivo) {
        this.urlDocumentoNuevo = URL.createObjectURL(archivo);
      } else {
        this.urlDocumentoNuevo = null;
      }
    },
    confirmarReemplazo() {
      if (!this.$refs.formReemplazo.validate()) {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Por favor, seleccione un archivo válido',
          type: 'error',
        });

        return;
      }

      this.dialogConfirmacion = true;
    },
    async reemplazarDocumento() {
      if (!this.nuevoArchivo || !this.inscripcion || !this.inscripcionDocumentoPersonaId) {
        return;
      }

      if (!this.$refs.formReemplazo.validate()) {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Por favor, ingrese todos los datos requeridos para el nuevo documento',
          type: 'error',
        });

        return;
      }

      this.reemplazando = true;

      try {
        const archivoBase64 = await this.archivoABase64(this.nuevoArchivo);

        this.documentoPersonaNuevo.archivoBase64 = archivoBase64;
        this.documentoPersonaNuevo.tipoDocumentoPersonaId = this.tipoDocumentoPersona.id;

        const response = await inscripcionesDocumentosPersonasService.reemplazarDocumentoPersona(this.inscripcion.id, {
          inscripcionDocumentoPersonaId: this.inscripcionDocumentoPersonaId,
          documentoPersona: this.documentoPersonaNuevo,
        });

        const data = response.data;
        const mensaje = data.mensaje || 'Documento reemplazado correctamente';

        this.$notify({
          group: 'notifications',
          title: 'Éxito',
          text: mensaje,
          type: 'success',
        });

        this.$emit('documento-reemplazado');
        this.cerrar();
      } catch (err) {
        const response = err?.response;
        const data = response?.data;
        const mensaje = data?.mensaje || 'Error al reemplazar el documento';

        window.console.error('Error al reemplazar documento:', err);

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje,
          type: 'error',
        });
      } finally {
        this.reemplazando = false;
        this.dialogConfirmacion = false;
      }
    },
    base64AUrl(file64, mimetype) {
      try {
        const byteCharacters = atob(file64);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimetype });

        return URL.createObjectURL(blob);
      } catch (error) {
        window.console.error('Error al convertir base64 a blob:', error);
        return '';
      }
    },
    archivoABase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = (error) => reject(error);
      });
    },
    formatearFecha(fecha) {
      if (!fecha) {
        return '-';
      }

      return new Date(fecha).toLocaleString('es-BO', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
      });
    },
    descargarDocumentoActual() {
      if (!this.urlDocumentoActual || !this.inscripcionDocumentoPersona) {
        return;
      }

      const archivo = this.documentoPersona.archivo;
      const link = document.createElement('a');
      const tipoDocumentoPersonaNombre = this.tipoDocumentoPersona.nombre;
      const nombreCompletoEstudiante = this.nombreCompletoEstudiante.replace(/\s+/g, '_');

      link.href = this.urlDocumentoActual;
      link.download = `${nombreCompletoEstudiante}-${tipoDocumentoPersonaNombre}.${archivo.extencion}`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
  beforeDestroy() {
    if (this.urlDocumentoNuevo) {
      URL.revokeObjectURL(this.urlDocumentoNuevo);
    }
  },
};
</script>

<style scoped>
.documento-viewer {
  min-height: 400px;
  max-height: 500px;
  background-color: #f5f5f5;
  border-radius: 4px;
  overflow: hidden;
}

.v-card__subtitle {
  font-size: 1rem;
}
</style>
